export default __webpack_public_path__ + "locales/ja-JP/JavascriptSdk.json?hash=865f62bbe7d5e335954072051479f80d";